import Vue from 'vue'
import Router from 'vue-router'
import index from '@/pages/index/module/index'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'index',
      component: index
    }
  ],
  base: '/index',
  mode: 'history'
})



// WEBPACK FOOTER //
// ./src/pages/index/router/index.js